import { render, staticRenderFns } from "./AddPocComponent.vue?vue&type=template&id=1d80a00e&"
import script from "./AddPocComponent.vue?vue&type=script&lang=js&"
export * from "./AddPocComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports